export interface DokumentTyp {
  id              : number;
  messageProperty : string;
  maxUploadCount  : number;
  canDelete       : boolean;
  canMarkUnread   : boolean;
}

export enum DokumentTypId {
  DETAILHANDELS_BEWILLIGUNG_KANTON         = 20,
  BESTAETIGUNG_LIEFERENGPASS               = 40,
  BETAEUBUNGSMITTEL_BEWILLIGUNG_SWISSMEDIC = 50,
  LABORANALYSEN_AUTOVAKZINE                = 70,
  BEWILLIGUNG_BLV                          = 90
}
